// FILE: src/Components/Header.js (FULLY UPDATED)

import React from 'react';
import { useSelector } from 'react-redux';

export default function Header() {
  // Get the user profile directly from the Redux store.
  const profile = useSelector(state => state.Profiles[0]);

  return (
    <div className='header d-flex'>
      <div className='welcome_section d-flex'>
        {/* <img src={require('../Assets/Avtar.png')} className='avtar' alt="User Avatar" /> */}
        <div className='welcome_msg'>
          <h4>Welcome,{" "}
            {profile?.first_name || "User"}
          </h4>
        </div>
      </div>

      <div className='d-flex'>
        {/* --- THIS IS THE FIX --- */}
        {/* The "Buy subscription" button now only shows if the user does NOT have an active plan. */}
        {/* The "Trial" and "Cancel" buttons have been removed entirely. */}
        {!profile?.is_active_plan && (
          <button
            className='subscribe_btn btn'
            type='button'
            onClick={() => window.location.href = '/select-plan'}
          >
            Buy subscription
          </button>
        )}
        {/* --- END OF FIX --- */}
      </div>
    </div>
  );
}